import React, { useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { PageLoader } from "@/components/common/Loading";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Link2, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function CrmConfig() {
  const [rel, setRel] = useState(null); const [biz, setBiz] = useState(null);
  const [rl, setRl] = useState({ label: "", reciprocal_label: "" }); const [bl, setBl] = useState("");
  const load = useCallback(async () => {
    const [r, b] = await Promise.all([api.get("/relationship-types"), api.get("/business-types")]);
    setRel(r.data.items); setBiz(b.data.items);
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!rel || !biz) return <PageLoader />;
  const addRel = async () => { if (!rl.label.trim()) return; try { await api.post("/relationship-types", rl); setRl({ label: "", reciprocal_label: "" }); load(); toast.success("Added"); } catch (e) { toast.error(apiError(e)); } };
  const addBiz = async () => { if (!bl.trim()) return; try { await api.post("/business-types", { label: bl }); setBl(""); load(); toast.success("Added"); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div>
      <PageHeader title="Relationship & Business Types" description="Configure relationship types (with reciprocal labels) and Agency/Business types." />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="relationship-types-config">
          <h3 className="font-display font-semibold text-sm mb-3 flex items-center gap-1.5"><Link2 className="w-4 h-4 text-brand" /> Relationship Types</h3>
          <div className="flex gap-2 mb-4">
            <Input placeholder="Label (e.g. Partner Of)" value={rl.label} onChange={(e) => setRl({ ...rl, label: e.target.value })} data-testid="reltype-label" />
            <Input placeholder="Reciprocal" value={rl.reciprocal_label} onChange={(e) => setRl({ ...rl, reciprocal_label: e.target.value })} data-testid="reltype-reciprocal" />
            <Button onClick={addRel} className="bg-brand hover:bg-brand-strong shrink-0" data-testid="reltype-add"><Plus className="w-4 h-4" /></Button>
          </div>
          <ul className="space-y-1.5">{rel.map((t) => (
            <li key={t.id} className="flex items-center justify-between rounded-md border border-slate-100 px-3 py-2 text-sm">
              <span className="text-slate-700">{t.label} <span className="text-slate-400">↔ {t.reciprocal_label}</span></span>
              <span className="text-[10px] uppercase tracking-wide text-slate-400">{t.category}</span></li>))}</ul>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="business-types-config">
          <h3 className="font-display font-semibold text-sm mb-3 flex items-center gap-1.5"><Building2 className="w-4 h-4 text-brand" /> Business Types</h3>
          <div className="flex gap-2 mb-4">
            <Input placeholder="e.g. Marketing Org" value={bl} onChange={(e) => setBl(e.target.value)} data-testid="biztype-label" />
            <Button onClick={addBiz} className="bg-brand hover:bg-brand-strong shrink-0" data-testid="biztype-add"><Plus className="w-4 h-4" /></Button>
          </div>
          <ul className="space-y-1.5">{biz.map((t) => (
            <li key={t.id} className="rounded-md border border-slate-100 px-3 py-2 text-sm text-slate-700">{t.label}</li>))}</ul>
        </div>
      </div>
    </div>
  );
}
